export default __webpack_public_path__ + "c648bc4.png";